import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import { DetalleProduccion } from "./components/DetalleProduccion";
import "./styles/Producciones.css";

class CierreTurno extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    irATurno = () => {
        const queryParams = new URLSearchParams(this.props.location.search);
        const doubleregreso = queryParams.get("doubleregreso") === "true";
        
        if (doubleregreso) {
            // regresar 2 veces
            this.props.history.go(-2);
            return;
        }
        this.props.history.goBack();
    };

    render() {

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="produccion_activo"
                    titulo="Producción"
                    subtitulo="Cierre de turno"
                    noBorder
                >
                    <DetalleProduccion
                        regresar={this.regresar}
                        irATurno={this.irATurno}
                    />
                </Card>
            </div>
        );
    }
}



export default CierreTurno;
